// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2M9Mz","footer":"Form_footer__3PtFp"};